
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/win-disneyland-paris-tickets",
      function () {
        return require("private-next-pages/landing/win-disneyland-paris-tickets.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/win-disneyland-paris-tickets"])
      });
    }
  